export const CHECKLIST_STATUS = {
    OK: 'ok',
    CREATED: 'created',
    ACTION_NEEDED: 'action_needed',
    WARNING: 'warning'
};
export const CHECKLIST_ITEM_KEY = {
    TAG: 'tag',
    EQUIPMENT_TYPES: 'equipment_types',
    TECHNICIANS: 'technicians',
    JOB_CUSTOM_FIELD_PREFIX: 'job_custom_field:'
};
export const PULL_STATUS = {
    RUNNING: 'running',
    COMPLETE: 'complete',
    FAILED: 'failed'
};
export const PULL_POLL_INTERVAL_MS = 5000;
export const PULL_POLL_BACKOFF_FACTOR = 2;
export const PULL_POLL_MAX_DELAY_MS = 60000;
export const FAILURE_REASONS = {
    MISSING_REQUIRED_FIELD: 'missing_required_field',
    TENANT_CLAIM_MISSING: 'tenant_claim_missing',
    TENANT_ROUTE_COLLISION: 'tenant_route_collision',
    INVALID_CREDENTIALS: 'invalid_credentials',
    APP_NOT_CONNECTED: 'app_not_connected',
    UNREACHABLE: 'unreachable',
    ALREADY_RUNNING: 'already_running'
};
export const KNOWN_FAILURE_STEPS = [
    'inspection',
    'contact',
    'technician',
    'equipment',
    'finding',
    'attachment',
    'job_field'
];
export const STANDARD_EQUIPMENT_TYPE_NAMES = [
    'Deluge Sprinkler System',
    'Wet Sprinkler System',
    'Dry Sprinkler System',
    'Preaction Sprinkler System',
    'Diesel Fire Pump',
    'Diesel Pump Flow Meter',
    'Electric Fire Pump',
    'Electric Pump Flow Meter',
    'Emergency Generator',
    'Fire Hydrant',
    'Foam Water System',
    'Fuel Tank',
    'Fire Hoses',
    'Hose Valves',
    'Huguenot',
    'Nitrogen',
    'Private Fire Service Main',
    'Stand Pipe & Hose System',
    'Transfer Switch',
    'Water Storage Tanks',
    'CO2 Suppression System',
    'Kitchen Hood Suppression System',
    'Paint Spray Booth Suppression System',
    'Dry Chemical Suppression System',
    'Aerosol System',
    'Clean Agent System',
    'Halon System',
    'Vehicle Suppression System',
    'Vortex System',
    'Water Mist System',
    'Backflow',
    'Monitoring System',
    'Fire Damper',
    'Fire Extinguisher Group',
    'Exit Sign Group',
    'Fire Door Group',
    'Alarm System',
    'Building Valve'
];
export const STANDARD_EQUIPMENT_TYPE_ALIASES = {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- keyed by the ServiceTitan type name
    'Alarm System': ['Alarm Device']
};
export const CREATE_EQUIPMENT_TYPES_MAX = 40;
